/* NNM Freight Meter - preview build v3
   Streams: post = tubes + garden accessories; truck = 140mm pots and larger, litres, bags.
   Services (installation, gift cards, quotes, vouchers) carry no delivery at all.
   Config: window.NNM_FREIGHT */
(function () {
  if (window.__nnmFreightInit) return; /* script re-executed by theme section refresh - original instance keeps running */
  window.__nnmFreightInit = true;
  var CFG = window.NNM_FREIGHT || {};
  var POST_FLAT = CFG.postFlat || 29.95;
  var FLOOR = CFG.truckFloor || 179.95;
  var PCT = CFG.truckPct || 0.17;
  var BANDS = CFG.showBands && CFG.bands && CFG.bands.length ? CFG.bands : null;
  var CROSSOVER = Math.round((FLOOR / PCT) * 100) / 100;

  var ICON_TRUCK = '<svg class="nnm-fm-icon" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M3 7h11v10H3V7z" stroke="currentColor" stroke-width="1.8"/><path d="M14 10h4l3 3v4h-7v-7z" stroke="currentColor" stroke-width="1.8"/><path d="M7 19a2 2 0 100-4 2 2 0 000 4z" stroke="currentColor" stroke-width="1.8"/><path d="M18 19a2 2 0 100-4 2 2 0 000 4z" stroke="currentColor" stroke-width="1.8"/></svg>';
  var ICON_BOX = '<svg class="nnm-fm-icon" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M21 8.5l-9 4.5-9-4.5 9-4.5 9 4.5z" stroke="currentColor" stroke-width="1.8"/><path d="M3 8.5V17l9 4.5 9-4.5V8.5" stroke="currentColor" stroke-width="1.8"/><path d="M12 13v8.5" stroke="currentColor" stroke-width="1.8"/></svg>';

  function isService(title) {
    var t = (title || '').toLowerCase();
    return /installation|planting service|gift card|egift|e-gift|voucher|custom quote/.test(t);
  }

  function classify(title) {
    var t = (title || '').toLowerCase();
    if (t.indexOf('tube') !== -1) return 'post';
    if (/\d{2,3}\s*mm/.test(t)) return 'truck';
    if (/\b\d+(\.\d+)?\s*l(itre)?\b/.test(t)) return 'truck';
    if (t.indexOf('bag') !== -1) return 'truck';
    return 'post'; /* garden accessories and anything unsized */
  }

  function money(n) {
    return '$' + n.toFixed(2).replace(/\.00$/, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function moneyR(n) {
    return '$' + Math.floor(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function bandFor(sub) {
    for (var i = 0; i < BANDS.length; i++) {
      if (sub <= BANDS[i][0]) {
        var nxt = BANDS[i + 1];
        return { cap: BANDS[i][0], price: BANDS[i][1], nextCap: nxt ? nxt[0] : null, nextPrice: nxt ? nxt[1] : null };
      }
    }
    var lastB = BANDS[BANDS.length - 1];
    return { cap: lastB[0], price: lastB[1], nextCap: null, nextPrice: null };
  }

  function truckRow(truck) {
    var cap = CROSSOVER, price = FLOOR, nextCap = null, nextPrice = null, tier = 1, tiers = 1;
    if (BANDS) {
      var b = bandFor(truck); cap = b.cap; price = b.price; nextCap = b.nextCap; nextPrice = b.nextPrice;
      tiers = BANDS.length;
      for (var i = 0; i < BANDS.length; i++) { if (BANDS[i][0] === cap) { tier = i + 1; break; } }
    }
    var pc = Math.min(100, Math.round((truck / cap) * 100));
    var label = (BANDS && tier > 1 ? 'Tier ' + tier + ' &middot; ' : '') + pc + '% full';
    var h = '<div class="nnm-fm-row">' + ICON_TRUCK + '<div class="nnm-fm-body">';
    h += '<p class="nnm-fm-head">Plant truck <span class="nnm-fm-pct">' + label + '</span></p>';
    h += '<div class="nnm-fm-bar"><span style="width:' + pc + '%"></span></div>';
    if (truck < cap) {
      h += '<p class="nnm-fm-big">' + moneyR(cap - truck) + ' more travels with no extra freight</p>';
      h += '<p class="nnm-fm-sub">One delivery covers up to ' + moneyR(cap) + ' of large plants.</p>';
      if (BANDS && nextCap && pc >= 50) {
        h += '<p class="nnm-fm-tease">Next tier: covers up to ' + moneyR(nextCap) + ' of plants at a more economical freight rate.</p>';
      }
    } else {
      h += '<p class="nnm-fm-big">Delivery now grows with truck space</p>';
      h += '<p class="nnm-fm-sub">Beyond ' + moneyR(cap) + ', your delivery fee grows with the room your plants take on the truck &mdash; always passed through at cost.</p>';
    }
    h += '</div></div>';
    return h;
  }

  function postRow(compact) {
    var h = '<div class="nnm-fm-row">' + ICON_BOX + '<div class="nnm-fm-body">';
    h += '<p class="nnm-fm-head">Tubes &amp; garden accessories</p>';
    h += '<p class="nnm-fm-sub nnm-fm-solo">Ships by post. Flat ' + money(POST_FLAT) + ' postage' + (compact ? '.' : ', however many you add.') + '</p>';
    h += '</div></div>';
    return h;
  }

  function potRow() {
    var h = '<div class="nnm-fm-row">' + ICON_TRUCK + '<div class="nnm-fm-body">';
    h += '<p class="nnm-fm-head">Pots &amp; planters</p>';
    h += '<p class="nnm-fm-sub nnm-fm-solo">Delivery calculated at checkout by size and delivery postcode.</p>';
    h += '</div></div>';
    return h;
  }

  function render(el, cart) {
    var post = 0, truck = 0, pots = 0;
    (cart.items || []).forEach(function (it) {
      if (isService(it.product_title)) return; /* services carry no delivery */
      var amt = (it.final_line_price != null ? it.final_line_price : it.line_price) / 100;
      if ((it.product_type || '') === 'Pots') { pots += amt; return; }
      var stream = classify((it.variant_title || '') + ' ' + (it.product_title || ''));
      if (stream === 'truck') truck += amt; else post += amt;
    });

    if (!post && !truck && !pots) { el.style.display = 'none'; return; }
    var compact = el.getAttribute('data-compact') === '1';

    /* two-zone card: .nnm-zone re-renders freely, the suggestion row lives beside it
       and is NEVER touched by meter refreshes */
    var card = el.querySelector('.nnm-fm-card');
    if (!card) {
      el.innerHTML = '<div class="nnm-fm-card"><div class="nnm-zone"></div></div>';
      card = el.querySelector('.nnm-fm-card');
    }
    var zone = card.querySelector('.nnm-zone');
    if (!zone) { zone = document.createElement('div'); zone.className = 'nnm-zone'; card.insertBefore(zone, card.firstChild); }

    var h = '<p class="nnm-fm-title">Delivery</p>';
    if (truck) h += truckRow(truck);
    if (post) h += postRow(compact);
    if (pots) h += potRow();
    if (post && truck && !compact) {
      h += '<p class="nnm-fm-note">Your order travels as two deliveries: large plants by truck, tubes and accessories by post.</p>';
    }
    if (pots && (post || truck) && !compact) {
      h += '<p class="nnm-fm-note">Pots are dispatched separately from live plants.</p>';
    }
    if (zone.__nnmH !== h) { zone.innerHTML = h; zone.__nnmH = h; }

    /* keep the persistent suggestion row attached (after the zone) */
    if (!compact && window.__nnmSugNode && !card.contains(window.__nnmSugNode)) {
      if (!card.querySelector('.nnm-sug')) card.appendChild(window.__nnmSugNode);
    }
    el.style.display = 'block';
  }

  var timer = null;
  function refresh() {
    var els = document.querySelectorAll('[data-nnm-freight-meter]');
    if (!els.length) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        window.__nnmLastCart = cart;
        els.forEach(function (el) { render(el, cart); });
        if (window.NNM_scheduleSug) window.NNM_scheduleSug();
      })
      .catch(function () {});
  }
  function debounced() { clearTimeout(timer); timer = setTimeout(refresh, 150); }

  /* instant updates: refresh the moment any cart mutation completes */
  var _fetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0] && (arguments[0].url || arguments[0]);
    var p = _fetch.apply(this, arguments);
    if (typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url)) {
      p.then(function () { debounced(); }).catch(function () {});
    }
    return p;
  };
  var _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, url) {
    if (typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url)) {
      this.addEventListener('loadend', debounced);
    }
    return _open.apply(this, arguments);
  };

  document.addEventListener('DOMContentLoaded', refresh);
  ['cart:updated', 'cart:change', 'cart:refresh', 'on:cart:add', 'dispatch:cart-drawer:refresh'].forEach(function (ev) {
    document.addEventListener(ev, debounced);
  });
  setInterval(refresh, 10000);
  refresh();

  /* the theme re-renders the cart section after quantity changes, wiping our card.
     MutationObserver callbacks run BEFORE the browser paints, so a synchronous
     restore here means the wiped state is never visible on screen. */
  try {
    new MutationObserver(function () {
      var meter = document.querySelector('[data-nnm-freight-meter]:not([data-compact])');
      if (!meter) return;
      var needsMeter = !meter.querySelector('.nnm-fm-card');
      var needsSug = window.__nnmSugNode && !document.querySelector('.nnm-sug');
      if (!needsMeter && !needsSug) return;
      if (window.__nnmLastCart) {
        document.querySelectorAll('[data-nnm-freight-meter]').forEach(function (el) {
          el.__nnmH = '';
          render(el, window.__nnmLastCart); /* synchronous, pre-paint */
        });
      }
      debounced(); /* fetch fresh numbers in the background */
    }).observe(document.body, { childList: true, subtree: true });
  } catch (e) {}

  /* ---- product page delivery badge (relocates into the trust bar, under the ETA card) ---- */
  function relocate(badge) {
    var trust = document.querySelector('.nnm-trust');
    if (trust && badge.parentElement !== trust) trust.appendChild(badge);
  }
  function paintBadge() {
    var badge = document.querySelector('[data-nnm-delivery]');
    if (!badge) return;
    if (badge.getAttribute('data-skip') === '1') { badge.style.display = 'none'; return; }
    var vt = '';
    try {
      var inp = document.querySelector('form[action*="/cart/add"] [name="id"], .js-product-form-main [name="id"]');
      var data = document.querySelector('[data-nnm-bo-variants]');
      if (inp && data) {
        var id = parseInt(inp.value, 10);
        JSON.parse(data.textContent).forEach(function (v) { if (v.id === id) vt = v.t; });
      }
    } catch (e) {}
    /* pots: dimensions are in cm and freight is size- and postcode-based, so the
       plant post/truck split does not apply - render a dedicated pot badge once */
    if (badge.getAttribute('data-pot') === '1') {
      relocate(badge);
      if (badge.getAttribute('data-nnm-stream') !== 'pot') {
        badge.setAttribute('data-nnm-stream', 'pot');
        badge.innerHTML = '<div class="nnm-badge-grid">' + ICON_TRUCK + '<div>'
          + '<p class="nnm-badge-head">Pot delivery Australia-wide</p>'
          + '<p class="nnm-badge-sub">Calculated at checkout by size and delivery postcode. Small pots travel by post, large and statement pots by freight.</p>'
          + '</div></div>';
      }
      badge.style.display = 'block';
      return;
    }
    if (!vt) { badge.style.display = 'none'; return; }
    relocate(badge);
    var stream = classify(vt);
    if (badge.getAttribute('data-nnm-stream') === stream) return;
    badge.setAttribute('data-nnm-stream', stream);
    if (stream === 'post') {
      badge.innerHTML = '<div class="nnm-badge-grid">' + ICON_BOX + '<div>'
        + '<p class="nnm-badge-head">Ships by post</p>'
        + '<p class="nnm-badge-sub">Flat ' + money(POST_FLAT) + ' postage for tubes and garden accessories, however many you order.</p>'
        + '</div></div>';
    } else {
      badge.innerHTML = '<div class="nnm-badge-grid">' + ICON_TRUCK + '<div>'
        + '<p class="nnm-badge-head">Specialist plant transport</p>'
        + '<p class="nnm-badge-sub">We compare freight quotes from plant carriers for you. One delivery covers up to ' + moneyR(CROSSOVER) + ' of large plants.</p>'
        + '</div></div>';
    }
    badge.style.display = 'block';
  }
  setInterval(paintBadge, 600);
  document.addEventListener('change', function () { setTimeout(paintBadge, 60); }, true);
  paintBadge();

  /* ---- same-farm "fill your truck" suggestions (cart page only, size-aware) ---- */
  var FARM_DATA = null, FARM_URL = CFG.farmDataUrl || null, sugBusy = false;
  function loadFarmData() {
    if (FARM_DATA || !FARM_URL) return Promise.resolve(FARM_DATA);
    return fetch(FARM_URL).then(function (r) { return r.json(); }).then(function (d) {
      if (d && !d.products) d = { _r: {}, products: d }; /* tolerate old shape */
      FARM_DATA = d; return d;
    });
  }
  function rating(sid) { var r = (FARM_DATA._r || {})[String(sid)]; return r == null ? 3 : r; }
  function commonName(title) { return (title || '').split(' - ')[0]; }

  function sizeTokens(title) {
    var t = (title || '').toLowerCase(), out = [];
    var m = t.match(/(\d{2,3})\s*mm/); if (m) out.push(m[1] + 'mm');
    m = t.match(/(\d+)(?:\.\d+)?\s*l\b/); if (m) out.push(m[1] + 'L');
    return out;
  }

  function pickSuggestions(cart, remaining) {
    var P = FARM_DATA.products, inCart = {}, farmValue = {}, cartGenera = {};
    (cart.items || []).forEach(function (it) {
      inCart[it.handle] = 1;
      var e = P[it.handle];
      if (!e) return;
      cartGenera[e.g] = 1;
      var amt = (it.final_line_price != null ? it.final_line_price : it.line_price) / 100;
      Object.keys(e.f).forEach(function (f) {
        if (rating(f) <= 1) return;
        farmValue[f] = (farmValue[f] || 0) + amt * (rating(f) / 3);
      });
    });
    var best = null, bestV = 0;
    Object.keys(farmValue).forEach(function (f) { if (farmValue[f] > bestV) { bestV = farmValue[f]; best = f; } });
    if (best === null) return { farm: null, picks: [] };
    var cands = [];
    Object.keys(P).forEach(function (h) {
      if (inCart[h]) return;
      var e = P[h];
      if (!e.f[best]) return;
      if (e['$'] > Math.max(remaining, 120)) return;
      cands.push({ h: h, sizes: e.f[best], sameGenus: cartGenera[e.g] ? 1 : 0, p: e.p, price: e['$'] });
    });
    cands.sort(function (a, b) { return (b.sameGenus - a.sameGenus) || (b.p - a.p) || (b.price - a.price); });
    return { farm: best, picks: cands.slice(0, 8) };
  }

  function bestTruckVariant(pjson, allowedSizes) {
    var best = null;
    (pjson.variants || []).forEach(function (v) {
      var t = (v.title || '').toLowerCase();
      if (t.indexOf('tube') !== -1 || t.indexOf('pack') !== -1) return;
      if (!(/\d{2,3}\s*mm/.test(t) || /\b\d+(\.\d+)?\s*l\b/.test(t) || t.indexOf('bag') !== -1)) return;
      if (!v.available) return;
      if (allowedSizes && allowedSizes.length) {
        var toks = sizeTokens(v.title), hit = false;
        toks.forEach(function (tok) { if (allowedSizes.indexOf(tok) !== -1) hit = true; });
        if (!hit) return; /* farm does not grow this size */
      }
      if (!best || v.price < best.price) best = v;
    });
    return best;
  }

  function renderSuggestions(cart, remaining) {
    var meters = document.querySelectorAll('[data-nnm-freight-meter]');
    var host = null;
    meters.forEach(function (m) { if (m.getAttribute('data-compact') !== '1') host = m.querySelector('.nnm-fm-card'); });
    if (!host) return;
    function clear() { var o = document.querySelector('.nnm-sug'); if (o) o.remove(); window.__nnmSugNode = null; }
    var res = pickSuggestions(cart, remaining);
    if (!res.picks.length) { clear(); return; }

    var cache = window.__nnmProdCache = window.__nnmProdCache || {};
    function getP(h) {
      if (cache[h]) return Promise.resolve(cache[h]);
      return fetch('/products/' + h + '.js').then(function (r) { return r.json(); })
        .then(function (p) { cache[h] = p; return p; }).catch(function () { return null; });
    }
    var chosen = [];
    function step(i) {
      if (chosen.length >= 4 || i >= res.picks.length) return Promise.resolve();
      var c = res.picks[i];
      return getP(c.h).then(function (p) {
        if (p) { var v = bestTruckVariant(p, c.sizes); if (v) chosen.push({ c: c, p: p, v: v }); }
        return step(i + 1);
      });
    }
    step(0).then(function () {
      if (!chosen.length) { clear(); return; }
      var handles = chosen.map(function (x) { return x.c.h; }).join(',');
      var cur = document.querySelector('.nnm-sug');
      window.__nnmBestFarm = res.farm;
      if (cur && cur.getAttribute('data-handles') === handles) { window.__nnmSugNode = cur; return; } /* identical picks - zero DOM change */
      /* build the complete new row off-DOM, then swap atomically */
      var wrap = document.createElement('div');
      wrap.className = 'nnm-sug';
      wrap.setAttribute('data-handles', handles);
      var inner = '<p class="nnm-sug-head">Fill your truck &mdash; more from the same grower</p><div class="nnm-sug-row">';
      chosen.forEach(function (x) {
        var img = (x.p.featured_image || (x.p.images && x.p.images[0]) || '');
        if (img && img.indexOf('//') === 0) img = 'https:' + img;
        var sep = img.indexOf('?') === -1 ? '?' : '&';
        inner += '<div class="nnm-sug-card">'
          + '<a class="nnm-sug-img" href="/products/' + x.c.h + '">' + (img ? '<img loading="lazy" src="' + img + sep + 'width=160" alt="">' : '') + '</a>'
          + '<a class="nnm-sug-name" href="/products/' + x.c.h + '">' + commonName(x.p.title) + '</a>'
          + '<span class="nnm-sug-price">' + x.v.title.replace(/\s*\(backorder\)\s*/i, '') + ' &middot; $' + (x.v.price / 100).toFixed(2).replace(/\.00$/, '') + '</span>'
          + '<button type="button" class="nnm-sug-add" data-vid="' + x.v.id + '">Add</button>'
          + '</div>';
      });
      inner += '</div>';
      wrap.innerHTML = inner;
      cur = document.querySelector('.nnm-sug'); /* re-query in case DOM moved during fetches */
      if (cur) cur.replaceWith(wrap);
      else { var h2 = document.querySelector('[data-nnm-freight-meter]:not([data-compact]) .nnm-fm-card'); if (h2) h2.appendChild(wrap); }
      window.__nnmSugNode = wrap;
    });
  }

  /* one delegated handler for all Add buttons - survives any row rebuild */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.nnm-sug-add');
    if (!b || sugBusy) return;
    sugBusy = true; b.textContent = '...';
    var payload = { id: parseInt(b.getAttribute('data-vid'), 10), quantity: 1,
                    properties: { _nnm_suggested: 'same-grower' } };
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) })
      .then(function (r) {
        sugBusy = false;
        if (!r.ok) { b.textContent = 'Add'; return; }
        b.textContent = 'Added';
        /* stamp the order so ops can source from the engine's farm (visible on the order) */
        var _fid = String(window.__nnmBestFarm || '');
        var _fname = (FARM_DATA && FARM_DATA.n && FARM_DATA.n[_fid]) ? String(FARM_DATA.n[_fid]) + ' (#' + _fid + ')' : _fid;
        var attrs = { 'Preferred grower (auto)': _fname };
        fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: attrs }) })
          .then(function () { if (window.location.pathname.indexOf('/cart') === 0) window.location.reload(); })
          .catch(function () { if (window.location.pathname.indexOf('/cart') === 0) window.location.reload(); });
      })
      .catch(function () { sugBusy = false; b.textContent = 'Add'; });
  });

  function refreshSuggestions() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var truck = 0;
        (cart.items || []).forEach(function (it) {
          if (isService(it.product_title)) return;
          if (classify((it.variant_title || '') + ' ' + (it.product_title || '')) === 'truck')
            truck += (it.final_line_price != null ? it.final_line_price : it.line_price) / 100;
        });
        if (!truck) return;
        var sig = (cart.items || []).map(function (i) { return i.key + ':' + i.quantity; }).join('|');
        if (sig === window.__nnmSugSig && window.__nnmSugNode) {
          if (!document.contains(window.__nnmSugNode)) {
            var m2 = document.querySelector('[data-nnm-freight-meter]:not([data-compact]) .nnm-fm-card');
            if (m2 && !m2.querySelector('.nnm-sug')) m2.appendChild(window.__nnmSugNode);
          }
          return; /* cart unchanged - same row, no rebuild */
        }
        window.__nnmSugSig = sig;
        var cap = CROSSOVER, nextCap = null;
        if (BANDS) { var b = bandFor(truck); cap = b.cap; nextCap = b.nextCap; }
        var remaining = cap - truck;
        /* near the top of a tier, aim suggestions at the next tier instead */
        if (remaining < 150 && nextCap) remaining = nextCap - truck;
        /* full or overflowing truck: keep suggesting from the same grower with no price ceiling */
        if (remaining < 300) remaining = 99999;
        loadFarmData().then(function (d) { if (d) renderSuggestions(cart, remaining); });
      }).catch(function () {});
  }
  var sugTimer = null;
  window.NNM_scheduleSug = function () {
    clearTimeout(sugTimer);
    sugTimer = setTimeout(refreshSuggestions, 350);
  };
  if (document.querySelector('[data-nnm-freight-meter]:not([data-compact])') || window.location.pathname.indexOf('/cart') === 0) {
    setTimeout(refreshSuggestions, 900);
  }
})();
